<template>
    <div class="row">
        <div class="col-md-6">
            <template v-if="isProductLoading">
                <div class="skeleton-progress progress" style="margin-bottom: 4px; width: 100%; height: 4em;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                </div>
                <div class="skeleton-progress progress" style="width: 100%; height: 4em;">
                    <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                </div>
            </template>    
            <template v-else>
                <select class="form-control" v-model="gift_card.program_id" @change="clear_default(); get_products();">
                    <option v-for="program in programs" :value="program.programid" :key="program.programid">{{ program.name }}</option>
                </select>
                <select class="form-control mt-1" v-model="gift_card.sku" @change="clear_default(); set_gift_card();">
                    <option v-for="product in products" :value="product.sku" :key="product.sku">{{ product.name }}</option>
                </select>
                <template v-if="gift_card.is_fixed">
                    <select class="form-control mt-1 mb-1" v-model="gift_card.amount" style="width: 8em;" @change="$emit('select', gift_card)">
                        <option v-for="(value, key) in gift_card.denomination.fixed" :value="value.value" :key="key">{{ value.value }} {{ gift_card.currency }}</option>
                    </select>
                </template>
                <template v-else>
                    <div class="d-flex align-items-center mt-1 mb-1">
                        <span class="mr-1">Min: {{ gift_card.denomination.range[0].min }} {{ gift_card.currency }}</span>
                        <input type="number" v-model="gift_card.amount" class="form-control" style="width: 5em;" :min="gift_card.denomination.range[0].min" :max="gift_card.denomination.range[0].max" @change="$emit('select', gift_card)">
                        <span class="ml-1">Max: {{ gift_card.denomination.range[0].max }} {{ gift_card.currency }}</span>
                    </div>
                </template>
            </template> 
        </div>
        <div class="col-md-6">
            <div class="faceplate-wrap">
                <template v-if="isFaceplateLoading">
                    <div class="skeleton-progress progress m-auto" style="width: 16em; height: 10em;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated" style="width: 100%;"></div>
                    </div>
                </template>
                <template v-else>
                    <div class="text-center"><img :src="gift_card.faceplate"></div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isProductLoading: false,
            isFaceplateLoading: false,
            programs: [],
            products: [],
            hasDefault: false,
            gift_card: {
                program_id: '',
                sku: '',
                faceplate: '',
                name: '',
                amount: '',
                currency: '',
                denomination: [],
                is_fixed: true
            }
        }
    },
    props: {
        default_gift_card: Object
    },
    watch: {
        default_gift_card(v) {
            if(v && Object.keys(v).length > 0) {
                this.gift_card = v
                this.hasDefault = true
            }
        }
    },
    mounted() {
        this.get_programs()
    },
    methods: {
        get_programs() {
            this.isProductLoading = true
            this.isFaceplateLoading = true
            this.products = []

            this.$http.get('/api/gift_cards/programs')
                .then(response => {
                    this.programs = response.data.data.program
                    if(this.programs[0] != undefined) {
                        if(!this.hasDefault) {
                            this.gift_card.program_id = this.programs[0].programid
                        }
                        this.get_products()
                    }
                })
        },
        get_products() {
            this.isProductLoading = true
            this.isFaceplateLoading = true
            this.products = []
            if(!this.hasDefault) {
                this.gift_card.sku = ''
            }

            this.$http.get('/api/gift_cards/programs/' + this.gift_card.program_id + '/products')
                .then(response => {
                    this.products = response.data.data.products
                    if(this.products[0] != undefined) {
                        if(!this.hasDefault) {
                            this.gift_card.sku = this.products[0].sku
                        }
                        this.set_gift_card()
                    }
                    this.isProductLoading = false
                })
        },
        set_gift_card() {
            for(let row in this.products) {
                if(this.products[row].sku == this.gift_card.sku) {
                    this.gift_card.name = this.products[row].name
                    this.gift_card.currency = this.products[row].currency
                    this.gift_card.denomination = this.products[row].denomination

                    if(this.gift_card.denomination.fixed.length == 0) {
                        this.gift_card.is_fixed = false
                        if(!this.hasDefault) {
                            this.gift_card.amount = this.gift_card.denomination.range[0].min
                        }
                    } else {
                        this.gift_card.is_fixed = true
                        if(!this.hasDefault) {
                            this.gift_card.amount = this.gift_card.denomination.fixed[0].value
                        }
                    }
                    break
                }
            }
            if(!this.hasDefault) {
                this.get_faceplate()
            } else {
                this.isFaceplateLoading = false
            }
            this.$emit('select', this.gift_card)
        },
        get_faceplate() {
            if(this.gift_card.sku != undefined) {
                this.isFaceplateLoading = true
                this.$http.get('/api/gift_cards/' + this.gift_card.sku + '/faceplate')
                    .then(response => {
                        this.gift_card.faceplate = response.data.data.product.faceplate
                        this.isFaceplateLoading = false
                    })
            }
        },
        clear_default() {
            this.default_gift_card = {}
            this.hasDefault = false
        }
    }
}
</script>
<style lang="scss" scoped>
.faceplate-wrap {
    height: 140px;
}
</style>